var screen = {
  small: '740px',
  medium: '1024px',
  large: '1440px'
};

var media = function media(size) {
  if (size) {
    return "@media (min-width: ".concat(screen[size], ")");
  }

  return 'inherit';
};

var container = {
  small: '880px',
  medium: '1200px',
  large: '1440px'
};
export { media, screen, container };